export default {
	data() {
		return {
			telenorIdUser: null,
		};
	},
};
